import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedUpload = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_111_642)">
          <g filter="url(#filter0_di_111_642)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0602 7.79604C11.0835 7.76228 11.1062 7.72811 11.1284 7.69353C11.166 7.72878 11.2046 7.76297 11.2442 7.79604H11.0602ZM5.16854 14.2369C5.17658 14.237 5.18462 14.237 5.19267 14.237C5.20072 14.237 5.20876 14.237 5.2168 14.2369H14.8392C14.8472 14.237 14.8553 14.237 14.8633 14.237C14.8714 14.237 14.8794 14.237 14.8875 14.2369H15.1708V14.2256C17.2892 14.0684 18.959 12.2999 18.959 10.1413C18.959 8.14905 17.5365 6.48903 15.6518 6.12148C15.6712 5.99077 15.6813 5.85702 15.6813 5.72091C15.6813 4.22766 14.4708 3.01714 12.9775 3.01714C12.2623 3.01714 11.6119 3.29487 11.1283 3.74837C10.478 2.73482 9.34121 2.06323 8.04755 2.06323C6.02741 2.06323 4.38977 3.70088 4.38977 5.72101C4.38977 5.81802 4.39355 5.91415 4.40096 6.00926C2.48679 6.37887 1.04111 8.06332 1.04111 10.0854C1.04111 12.3133 2.79602 14.1313 4.99892 14.2325V14.2369H5.16854Z"
              fill="url(#paint0_linear_111_642)"
            />
          </g>
          <g filter="url(#filter1_d_111_642)">
            <path
              d="M15.2604 11.3301L9.71483 5.47573L4.06933 11.3302L7.11913 11.3302C7.29778 12.6116 8.21629 16.417 9.71509 19.1648C11.3605 15.5826 12.0128 13.7691 12.4627 11.3301L15.2604 11.3301Z"
              fill="url(#paint1_linear_111_642)"
            />
            <path
              d="M7.36673 11.2957L7.33669 11.0802L7.11913 11.0802L4.65771 11.0802L9.71321 5.83756L14.6792 11.0801L12.4627 11.0801L12.2545 11.0801L12.2168 11.2848C11.7921 13.5877 11.1862 15.3263 9.69979 18.5968C8.3578 15.9307 7.53302 12.4884 7.36673 11.2957Z"
              stroke="url(#paint2_linear_111_642)"
              strokeOpacity="0.4"
              strokeWidth="0.5"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_di_111_642"
            x="-0.958892"
            y="1.06323"
            width="21.9179"
            height="16.1738"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_111_642" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_111_642" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.5" dy="0.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_111_642" />
          </filter>
          <filter
            id="filter1_d_111_642"
            x="2.06933"
            y="4.47573"
            width="15.1911"
            height="17.6891"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_111_642" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_111_642" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_111_642"
            x1="10.0001"
            y1="2.73355"
            x2="10.0001"
            y2="14.2368"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#83E1FF" />
            <stop offset="1" stopColor="#0074C7" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_111_642"
            x1="10.0356"
            y1="19.1648"
            x2="10.0356"
            y2="8.0208"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CE00AD" />
            <stop offset="1" stopColor="#FFC700" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_111_642"
            x1="5.99018"
            y1="8.61568"
            x2="13.4184"
            y2="18.2329"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <clipPath id="clip0_111_642">
            <rect width={size} height={size} fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedUpload
